import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10.02 18l6-6-6-6-1.41 1.41L13.19 12l-4.58 4.59z"
}), 'NavigateNextTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NavigateNextTwoTone.js
// module id = 5000
// module chunks = 2